<template>
  <div class="partner-invite">
    <!-- 顶部欢迎文案 -->
    <div class="welcome-box">
      <p>尊敬的{{ welcomeName }}，热烈欢迎您已成为盘雷第{{ memberOrder }}位重要的采购伙伴。</p>
      <p>&nbsp;&nbsp;盘雷愿成为您供应链上的得力数字伙伴，这个完全免费的平台，能为您解决以下核心痛点：</p>
      <p>
        &nbsp;&nbsp;选型询价慢：覆盖超2000万型号的数据库与AI选型，助您快速定位；一键询价，自动汇总报价。
        供应商管理余：可邀请您的供应商上线，将其产品信息为您所用，实现分类、筛选与高效协同。
      </p>
      <p>
        &nbsp;&nbsp;人脉资源散：邀请您的供应商或采购同行入驻，可将其转化为您的"资源资产"，享受邀请奖励，并让您的采购网络自动延伸。
      </p>
      <p>&nbsp;&nbsp;若追求极致效率，会员服务可为您打开定向供应商资源的直通车。</p>
      <p class="growth-tip">
        &nbsp;&nbsp;成长邀请：建议您从推广官1级起步，精通各项采购利器，当您晋升至2级，使有资格申请成为盘雷开发者合伙人，与我们共享生态的长期价值与核心资源。
      </p>
    </div>

    <!-- 标签页 -->
    <el-tabs class="invite-tabs">
      <el-tab-pane label="基础信息">
        <el-row :gutter="20">
          <!-- 左侧：用户基础信息卡片 -->
          <el-col :span="8">
            <div class="info-card">
              <div class="user-info-wrapper">
                <el-avatar size="large" class="user-avatar"></el-avatar>
                <div class="user-detail">
                  <div class="name-row">
                    <span class="label">名字：</span>
                    <el-input v-model="formData.name" size="default" class="name-input" />
                  </div>
                  <p class="info-line">
                    <span class="label">盘雷ID：</span>
                    <span class="value">{{ displayValue(formData.panLeiId) }}</span>
                  </p>
                  <div class="user-type-row">
                    <span class="label">用户类型：</span>
                    <el-radio-group v-model="formData.userType" size="default" disabled>
                      <el-radio label="factory">厂家</el-radio>
                      <el-radio label="supplier">供应商</el-radio>
                      <el-radio label="client">客户</el-radio>
                    </el-radio-group>
                  </div>
                  <p class="tip-text">(联系盘雷客服修改类型)</p>
                  <p class="info-line">
                    <span class="label">手机号（登录名）：</span>
                    <span class="value">{{ displayValue(formData.phone) }}</span>
                  </p>
                  <p class="info-line">
                    <span class="label">企业名称：</span>
                    <span class="value">{{ displayValue(formData.enterpriseName) }}</span>
                  </p>
                  <p class="info-line">
                    <span class="label">企业ID：</span>
                    <span class="value">{{ displayValue(formData.enterpriseId) }}</span>
                  </p>
                </div>
              </div>
              <div class="btn-group">
                <el-button size="default" @click="handleCancel">取消</el-button>
                <el-button type="primary" size="default" class="confirm-btn" @click="handleConfirm">确认</el-button>
              </div>
            </div>
          </el-col>

          <!-- 中间：入驻与邀请人信息卡片 -->
          <el-col :span="8">
            <div class="info-card">
              <div class="settle-content">
                <p class="settle-title">
                  您已入驻盘雷<span class="red-num">{{ settleYears }}</span>年<span class="red-num">{{ settleMonths }}</span>个月
                </p>
                <el-divider />
                <p class="inviter-title">盘雷数字合作伙伴（邀请人）：</p>
                <p class="inviter-line">
                  <span class="label">名字：</span>
                  <span class="value">{{ displayValue(inviterInfo.name) }}</span>
                </p>
                <p class="inviter-line">
                  <span class="label">手机号：</span>
                  <span class="value">{{ displayValue(inviterInfo.phone) }}</span>
                </p>
                <p class="inviter-line">
                  <span class="label">ID：</span>
                  <span class="value">{{ displayValue(inviterInfo.id) }}</span>
                </p>
                <p class="inviter-line">
                  <span class="label">企业：</span>
                  <span class="value">{{ displayValue(inviterInfo.enterprise) }}</span>
                </p>
                <p class="inviter-line">
                  <span class="label">入驻时间：</span>
                  <span class="value">{{ displayValue(inviterInfo.settleTime) }}</span>
                </p>
              </div>
              <div class="stat-bar">
                <div class="stat-item">
                  <span class="stat-label">供应商：</span>
                  <span class="stat-value">{{ displayValue(stats.supplier) }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">数字伙伴：</span>
                  <span class="stat-value">{{ displayValue(stats.partner) }}</span>
                </div>
              </div>
            </div>
          </el-col>

          <!-- 右侧：平台指定伙伴卡片 -->
          <el-col :span="8">
            <div class="info-card partner-apply-card">
              <div class="partner-title">
                <span class="partner-title-main">盘雷数字合作伙伴</span>
                <span class="partner-title-tag">盘雷平台指定</span>
              </div>
              <el-divider class="partner-divider" />
              <div v-if="hasPartnerApplyResult" class="partner-status-box">
                <div class="partner-status-panel">
                  <div class="partner-status-head">
                    <div class="partner-status-summary">
                      <p class="partner-status-caption">当前申请进度</p>
                      <p class="partner-status-main">{{ partnerApplyStatusText }}</p>
                    </div>
                    <el-tag :type="partnerApplyStatusTagType" effect="dark">{{ partnerApplyStatusText }}</el-tag>
                  </div>
                  <div class="partner-status-meta">
                    <div class="partner-status-meta-card partner-status-time-item">
                      <span class="label">申请时间</span>
                      <span class="value">{{ displayValue(currentPartnerApplyInfo.createTime) }}</span>
                    </div>
                    <div class="partner-status-meta-card partner-status-reason-item">
                      <span class="label">申请原因</span>
                      <span class="value">{{ displayValue(currentPartnerApplyInfo.applyReason) }}</span>
                    </div>
                  </div>
                  <div v-if="partnerApplyApproved" class="partner-profile-box">
                    <p class="partner-profile-title-fixed">原邀请人信息</p>
                    <div class="partner-profile-fixed-list">
                      <div class="partner-profile-fixed-row">
                        <span class="partner-profile-fixed-label">姓名</span>
                        <span class="partner-profile-fixed-value">{{ displayValue(approvedPartnerInfo.name) }}</span>
                      </div>
                      <div class="partner-profile-fixed-row">
                        <span class="partner-profile-fixed-label">手机号</span>
                        <span class="partner-profile-fixed-value">{{ displayValue(approvedPartnerInfo.phone) }}</span>
                      </div>
                      <div class="partner-profile-fixed-row">
                        <span class="partner-profile-fixed-label">企业</span>
                        <span class="partner-profile-fixed-value">{{ displayValue(approvedPartnerInfo.enterprise) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="false && partnerApplyApproved" class="partner-profile-box">
                    <p class="partner-profile-title">平台指定合作伙伴</p>
                    <div class="partner-status-grid partner-profile-grid">
                      <div class="partner-status-item partner-profile-item">
                        <span class="label">姓名</span>
                        <span class="value">{{ displayValue(approvedPartnerInfo.name) }}</span>
                      </div>
                      <div class="partner-status-item partner-profile-item">
                        <span class="label">手机号</span>
                        <span class="value">{{ displayValue(approvedPartnerInfo.phone) }}</span>
                      </div>
                      <div class="partner-status-item partner-status-item-full partner-profile-item">
                        <span class="label">企业</span>
                        <span class="value">{{ displayValue(approvedPartnerInfo.enterprise) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="currentPartnerApplyInfo.auditRemark" class="partner-note-box">
                    <span class="label">审核说明</span>
                    <p class="partner-note-text">{{ displayValue(currentPartnerApplyInfo.auditRemark) }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="empty-tip partner-empty-box">
                <p class="empty-title">暂无申请记录</p>
                <p class="empty-desc">如需平台指定合作伙伴，可填写申请原因后提交审核。</p>
              </div>
              <el-button
                size="default"
                class="apply-btn"
                :disabled="partnerApplyButtonDisabled"
                @click="openApplyDialog"
              >
                {{ partnerApplyButtonText }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <div class="partner-plan-page">
      <div class="partner-plan-content">
        <!-- 顶部弧形标题栏 -->
        <div class="header-container">
          <div class="title-bar">
            <span class="title-text">盘雷"数字合作伙伴"赋能计划：链动资源，共享红利</span>
          </div>
        </div>

        <!-- 模块1：致终端用户的一封信 -->
        <div class="module">
          <div class="module-title">
            <div>一</div>
            <span class="title-text">致终端用户的一封信</span>
          </div>
          <div class="letter-content">
            <p class="letter-greeting">尊敬的盘雷用户，您好！</p>
            <p>
              感谢您在您的朋友(即您的"盘雷数字合作伙伴")的邀请下，注册入驻盘雷工业数字链平台。这是一个致力于"互联互通，资源共享"的数字生态，我们相信"朋友的朋友可以成为朋友"，并通过技术连接产业链伙伴，让资源高效流动，创造共同价值。
            </p>
            <p>平台将协助您与您的邀请人(即您的"盘雷数字合作伙伴")携手，将您的人脉资源转化为切实的红利与收益。</p>

            <h4 class="section-title">您如何获得奖励？</h4>
            <p>邀请您的供应商或采购同行入驻盘雷，即可获得回报。奖励方式清晰灵活，任选其一：</p>
            <ol class="reward-list">
              <li>
                注册即得回报：成功邀请一家企业注册，无论其后续是否采购，您即可获得100元盘雷适用额度。该额度可在向您的盘雷数字合作伙伴采购时，按平台规则直接抵扣货款。
              </li>
              <li>
                采购成交奖现金：若您邀请的企业，与您指定的数字合作伙伴完成了采购，无论订单大小，您都可额外获得100元现金奖励。
              </li>
            </ol>
            <p class="tip-text">请注意：针对同一被邀请企业，上述两种奖励方式仅能享受其一。</p>

            <h4 class="section-title">特别激励与晋升通道</h4>
            <p>为感谢您为平台生态做出的贡献，我们设立特别激励与专属晋升通道：</p>
            <p>
              资源变现激励：如果您手头积累的供应商资源多达500家并成功邀请入驻，您将有可能获得高达5万元的特别奖励，并赢得成为盘雷开发者的珍贵机会，解锁全新的事业平台与收益模式。
            </p>

            <h4 class="section-title">您的权益，平台保障</h4>
            <p>您的收益默认由您的盘雷数字合作伙伴负责兑现。我们承诺保障您的应得权益：</p>
            <p>
              若您的合作伙伴未能及时兑现奖励，您可以向盘雷平台提交申请。一经核实，我们将：1，为您推荐并更新指定的数字合作伙伴，以确保您未来的奖励得以兑现。
            </p>
            <p>2，协助您追索此期应得的奖励。若原合作伙伴经协调仍拒不履行，平台将对其账户采取限制措施。</p>

            <p>再次感谢您的信任。期待与您及您的伙伴们在盘雷生态中挖掘更多资源价值，共享增长红利！</p>
            <p class="closing-text">二未来已来，你在哪级?盘雷路径：推广者→开发者→资源放大10倍</p>
          </div>
        </div>

        <!-- 模块2：成长路径与权益 -->
        <div class="module">
          <div class="module-title">
            <div>二</div>
            <span class="title-text">未来已来，你在哪级?盘雷路径：推广者→开发者→资源放大10倍</span>
          </div>
          <div class="benefits-content">
            <h4 class="benefits-title">盘雷推广者核心权益与规则说明</h4>
            <ul class="benefits-list">
              <li><strong>推广者2级：采购佣金</strong><br />您邀请的供应商通过平台采购，您最高可获得50%交易佣金。</li>
              <li><strong>推广者3级：会员分成</strong><br />您邀请的供应商购买任何盘雷会员，您均可获得50%销售分成。</li>
              <li>
                <strong>推广者4级：盘雷终身会员</strong
                ><br />盘雷终身会员，共享盘雷全平台供应商资源。所有品牌与价格对您开放查询，强力赋能您的销售业务。
              </li>
            </ul>

            <div class="rules-tip">
              <el-icon class="tip-icon"><Warning /></el-icon>
              <span class="tip-title">重要规则提示</span>
            </div>
            <p class="rules-text">
              统计标准：推广者等级仅统计由您邀请并新注册的供应商。<br />邀请与绑定：已注册用户无法再被邀请，但可添加为"绑定供应商"，建立合作联系。唯一性原则：任何供应商仅能成为一位推广者的"邀请供应商"。未来已来，尽快行动。使用盘雷工业数字链，抢占市场稀缺资源！
            </p>

            <div class="current-level">
              <span class="level-label">您当前为：</span>
              <el-tag type="success" class="level-tag">{{ devLevelText }}</el-tag>
              <span class="level-tip">(请尽快使用小程序/APP学习技巧，晋升至1级。)</span>
              <span class="level-desc">请使用小程序/APP学习技巧，晋升至1级。</span>
            </div>
          </div>
        </div>

        <!-- 模块3：网页邀请链接 -->
        <div class="invite-module">
          <div class="module-title">
            <div>三</div>
            <span class="title-text">网页邀请链接（推荐使用小程序链接邀请）</span>
          </div>

          <el-row :gutter="40" class="invite-content">
            <!-- 左侧：供应商邀请 -->
            <el-col :span="12" class="invite-col">
              <div class="invite-desc">
                <p>
                  请将此链接发送给您合作的各类供应商(厂家/代理/贸易商/门店)。使用盘雷，您可以便捷地一键发起询价，实时对比多家报价。同时，您邀请或绑定的供应商在平台上设置的品牌与产品信息，能直接为您所用，助您快速分类与管理供应商，从而高效完成采购。
                </p>
                <p>
                  此外，若您邀请的供应商是新注册的盘雷用户，系统会将其自动推荐给您的"盘雷数字合作伙伴"(即您的邀请人)。通过他，您还能加速升级推广者等级，解锁更多平台资源与权益。
                </p>
              </div>
              <div class="link-area">
                <div class="link-label">供应商邀请地址：</div>
                <div class="link-text">{{ displayValue(supplierLink) }}</div>
                <el-button type="text" class="copy-btn" @click="copy(supplierLink)">复制</el-button>
              </div>
            </el-col>

            <!-- 右侧：客户邀请 -->
            <el-col :span="12" class="invite-col">
              <div class="invite-desc">
                <p>请将您的专属注册链接发送给同属终端客户的朋友，例如：最终用户，设备制造商，盘柜厂及系统集成商等。</p>
                <p>
                  您成功邀请的每一位新客户，系统也会将其自动推荐给您的"盘雷数字合作伙伴"(即您的邀请人)。通过他，您同样可以为每位新客户获得100元盘雷适用额度或100元现金奖励。
                </p>
              </div>
              <div class="link-area">
                <div class="link-label">客户邀请地址：</div>
                <div class="link-text">{{ displayValue(customerLink) }}</div>
                <el-button type="text" class="copy-btn" @click="copy(customerLink)">复制</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <el-dialog v-model="applyDialogVisible" title="申请说明" width="520px">
      <div class="apply-dialog-tip">
        <p class="apply-dialog-tip-title">申请说明</p>
        <p class="apply-dialog-tip-text">申请时无需选择合作伙伴，只需填写申请原因，提交后由后台审核处理。</p>
      </div>
      <el-form ref="applyFormRef" :model="applyFormData" :rules="applyRules" label-width="80px">
        <el-form-item label="申请原因" prop="applyReason">
          <el-input
            v-model="applyFormData.applyReason"
            type="textarea"
            :rows="5"
            maxlength="500"
            show-word-limit
            placeholder="请输入申请原因"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="applyDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="applySubmitting" @click="submitPartnerApply">提交申请</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { Warning } from '@element-plus/icons-vue'
import { copyText } from '@/common/js/common.js'

const store = useStore()

const createEmptyFormData = () => ({
  name: '',
  panLeiId: '',
  userType: 'supplier',
  phone: '',
  enterpriseName: '',
  enterpriseId: ''
})

const createEmptyInviterInfo = () => ({
  name: '',
  phone: '',
  id: '',
  enterprise: '',
  settleTime: ''
})

const createEmptyStats = () => ({
  supplier: '',
  partner: ''
})

const createEmptyPartnerApplyInfo = () => ({
  status: '',
  statusName: '',
  createTime: '',
  applyReason: '',
  auditRemark: '',
  originInviterUserId: '',
  originInviterUserName: '',
  originInviterMobile: '',
  originInviterEnterpriseName: '',
  targetPartnerUserId: '',
  targetPartnerUserName: '',
  targetPartnerMobile: '',
  targetPartnerEnterpriseName: ''
})

const rawUserInfo = ref({})
const rawEnterpriseInfo = ref({})
const inviteDisplay = ref({})
const formData = ref(createEmptyFormData())
const initialFormData = ref(createEmptyFormData())
const inviterInfo = ref(createEmptyInviterInfo())
const stats = ref(createEmptyStats())
const currentPartnerApplyInfo = ref(createEmptyPartnerApplyInfo())
const applyDialogVisible = ref(false)
const applySubmitting = ref(false)
const applyFormRef = ref(null)
const applyFormData = ref({
  applyReason: ''
})
const applyRules = {
  applyReason: [
    { required: true, message: '请输入申请原因', trigger: 'blur' },
    { max: 500, message: '申请原因不能超过500个字', trigger: 'blur' }
  ]
}

const cloneData = value => JSON.parse(JSON.stringify(value))

const displayValue = value => {
  if (value === null || value === undefined || value === '') {
    return '--'
  }
  return value
}

const mapUserType = value => {
  if (value === '0' || value === 0 || value === 'supplier') {
    return 'supplier'
  }
  if (value === '1' || value === 1 || value === 'client' || value === 'customer') {
    return 'client'
  }
  if (value === 'factory') {
    return 'factory'
  }
  return 'supplier'
}

const parseMemberOrder = value => {
  if (!value) {
    return ''
  }
  const matched = String(value).trim().match(/(\d+)$/)
  if (!matched) {
    return ''
  }
  return String(Number(matched[1]))
}

const parseDateValue = value => {
  if (!value) {
    return null
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }
  const parsedDate = new Date(String(value).replace(/-/g, '/'))
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
}

const getSettleSourceTime = data =>
  data.createTime ||
  data.createDate ||
  data.registerTime ||
  data.gmtCreate ||
  data.entryTime ||
  data.joinTime ||
  ''

const settleDuration = computed(() => {
  const settleDate = parseDateValue(getSettleSourceTime(rawUserInfo.value))
  if (!settleDate) {
    return { years: 0, months: 0 }
  }
  const now = new Date()
  let years = now.getFullYear() - settleDate.getFullYear()
  let months = now.getMonth() - settleDate.getMonth()
  if (now.getDate() < settleDate.getDate()) {
    months -= 1
  }
  if (months < 0) {
    years -= 1
    months += 12
  }
  return {
    years: Math.max(years, 0),
    months: Math.max(months, 0)
  }
})

const settleYears = computed(() => settleDuration.value.years)
const settleMonths = computed(() => settleDuration.value.months)
const welcomeName = computed(() => displayValue(formData.value.name))
const memberOrder = computed(() => displayValue(parseMemberOrder(formData.value.panLeiId)))
const devLevelText = computed(() => {
  const level = rawUserInfo.value.devLevel
  if (level === null || level === undefined || level === '') {
    return '推广者0级'
  }
  return `推广者${level}级`
})

const currentUserId = computed(() => {
  const localUserInfo = localStorage.getItem('userInfo')
  if (localUserInfo) {
    try {
      const parsedUserInfo = JSON.parse(localUserInfo)
      if (parsedUserInfo?.userId) {
        return parsedUserInfo.userId
      }
    } catch (error) {}
  }
  return rawUserInfo.value.userId || rawUserInfo.value.id || ''
})

const normalizedPartnerApplyStatus = computed(() => {
  const status = currentPartnerApplyInfo.value.status
  if (status === null || status === undefined || status === '') {
    return ''
  }
  return String(status)
})

const partnerApplyStatusConfig = computed(() => {
  const statusMap = {
    0: {
      text: '待审核',
      type: 'warning'
    },
    1: {
      text: '审核通过',
      type: 'success'
    },
    2: {
      text: '审核拒绝',
      type: 'danger'
    },
    3: {
      text: '已撤销',
      type: 'info'
    }
  }
  return statusMap[normalizedPartnerApplyStatus.value] || null
})

const hasPartnerApplyResult = computed(() => {
  return (
    normalizedPartnerApplyStatus.value !== '' ||
    !!currentPartnerApplyInfo.value.applyReason ||
    !!currentPartnerApplyInfo.value.originInviterUserName ||
    !!currentPartnerApplyInfo.value.targetPartnerUserName
  )
})

const partnerApplyStatusText = computed(() => {
  return (
    currentPartnerApplyInfo.value.statusName ||
    partnerApplyStatusConfig.value?.text ||
    '--'
  )
})

const partnerApplyStatusTagType = computed(() => {
  return partnerApplyStatusConfig.value?.type || 'info'
})

const partnerApplyApproved = computed(() => normalizedPartnerApplyStatus.value === '1')
const approvedPartnerInfo = computed(() => {
  return {
    name: currentPartnerApplyInfo.value.originInviterUserName || '',
    phone: currentPartnerApplyInfo.value.originInviterMobile || '',
    enterprise: currentPartnerApplyInfo.value.originInviterEnterpriseName || ''
  }
})
const partnerApplyPending = computed(() => normalizedPartnerApplyStatus.value === '0')
const partnerApplyButtonDisabled = computed(() => partnerApplyPending.value)
const partnerApplyButtonText = computed(() => {
  return hasPartnerApplyResult.value ? '再次申请' : '立即申请'
})

const supplierLink = computed(() => {
  if (inviteDisplay.value.INVITE_SUPPLIER_LINK_ADMIN !== '1' || !currentUserId.value) {
    return ''
  }
  return `${window.location.protocol}//${window.location.host}/login/index?uid=${currentUserId.value}&belongType=0`
})

const customerLink = computed(() => {
  if (inviteDisplay.value.INVITE_CUSTOMER_LINK_ADMIN !== '1' || !currentUserId.value) {
    return ''
  }
  return `${window.location.protocol}//${window.location.host}/login/index?uid=${currentUserId.value}&belongType=1`
})

const loadPartnerApplyInfo = async () => {
  try {
    const res = await store.dispatch('myMessageModule/partnerApplyCurrent', {
      applicantUserId: currentUserId.value || undefined
    })
    const { code, data = {} } = res?.data || {}
    currentPartnerApplyInfo.value = code === '0' && data ? { ...createEmptyPartnerApplyInfo(), ...data } : createEmptyPartnerApplyInfo()
  } catch (error) {
    currentPartnerApplyInfo.value = createEmptyPartnerApplyInfo()
  }
}

const loadInviteDisplay = async () => {
  const userId = currentUserId.value
  if (!userId) {
    inviteDisplay.value = {}
    return
  }
  const [customerRes, supplierRes] = await Promise.allSettled([
    store.dispatch('systemModule/getDisplayTabListOfHome', {
      setTpCd: 'INVITE_CUSTOMER_LINK_ADMIN',
      sellerId: userId
    }),
    store.dispatch('systemModule/getDisplayTabListOfHome', {
      setTpCd: 'INVITE_SUPPLIER_LINK_ADMIN',
      sellerId: userId
    })
  ])

  inviteDisplay.value = {
    INVITE_CUSTOMER_LINK_ADMIN:
      customerRes.status === 'fulfilled' ? customerRes.value?.data?.data?.value || '' : '',
    INVITE_SUPPLIER_LINK_ADMIN:
      supplierRes.status === 'fulfilled' ? supplierRes.value?.data?.data?.value || '' : ''
  }
}

const loadEnterpriseInfo = async enterpriseId => {
  if (!enterpriseId) {
    rawEnterpriseInfo.value = {}
    return
  }
  try {
    const res = await store.dispatch('myMessageModule/getEnterprise', enterpriseId)
    const { code, data = {} } = res?.data || {}
    rawEnterpriseInfo.value = code === '0' ? data : {}
  } catch (error) {
    rawEnterpriseInfo.value = {}
  }
}

const fillPageData = userData => {
  formData.value = {
    ...createEmptyFormData(),
    name: userData.realName || '',
    panLeiId: userData.customerNumber || userData.userNumber || '',
    userType: mapUserType(userData.userType),
    phone: userData.mobilePhone || '',
    enterpriseName:
      userData.enterpriseName ||
      userData.enterpriseSimpleName ||
      rawEnterpriseInfo.value.enterpriseName ||
      '',
    enterpriseId:
      rawEnterpriseInfo.value.enterpriseCode ||
      userData.enterpriseCode ||
      userData.enterpriseNo ||
      userData.enterpriseId ||
      ''
  }

  initialFormData.value = cloneData(formData.value)

  inviterInfo.value = {
    ...createEmptyInviterInfo(),
    name: userData.inviteUserName || '',
    phone: userData.inviteUserPhone || '',
    id: userData.inviteUseCustomerNumber || '',
    enterprise: userData.inviteUserEnterpriseName || '',
    settleTime: userData.inviteUserCreateTime || ''
  }

  stats.value = {
    supplier: userData.inviteUserGysCount || '',
    partner: userData.inviteUserKhCount || ''
  }
}

const initPage = async () => {
  try {
    const userRes = await store.dispatch('myMessageModule/getUser')
    const { code, data = {} } = userRes?.data || {}
    if (code !== '0') {
      ElMessage.error(userRes?.data?.msg || '用户信息加载失败')
      return
    }
    rawUserInfo.value = data
    await loadEnterpriseInfo(data.enterpriseId)
    fillPageData(data)
    await Promise.all([loadInviteDisplay(), loadPartnerApplyInfo()])
  } catch (error) {
    ElMessage.error('用户信息加载失败')
  }
}

const handleCancel = () => {
  formData.value = cloneData(initialFormData.value)
}

const handleConfirm = async () => {
  const submitData = {
    ...cloneData(rawUserInfo.value),
    realName: formData.value.name
  }

  try {
    const res = await store.dispatch('myMessageModule/userEditUser', submitData)
    const { code, msg } = res?.data || {}
    if (code === '0') {
      ElMessage.success('修改成功')
      await initPage()
      return
    }
    ElMessage.error(msg || '修改失败')
  } catch (error) {
    ElMessage.error('修改失败')
  }
}

const copy = value => {
  if (!value) {
    ElMessage.warning('当前没有可复制的链接')
    return
  }
  copyText(value)
}

const resetPartnerApplyForm = () => {
  applyFormData.value = {
    applyReason: ''
  }
  applyFormRef.value?.clearValidate?.()
}

const openApplyDialog = () => {
  if (partnerApplyPending.value) {
    ElMessage.warning('当前申请正在审核中')
    return
  }
  resetPartnerApplyForm()
  applyDialogVisible.value = true
}

const submitPartnerApply = async () => {
  if (!applyFormRef.value) {
    return
  }

  try {
    await applyFormRef.value.validate()
  } catch (error) {
    return
  }

  applySubmitting.value = true
  try {
    const res = await store.dispatch('myMessageModule/partnerApplyCreate', {
      applyReason: applyFormData.value.applyReason.trim()
    })
    const { code, msg } = res?.data || {}
    if (code === '0') {
      ElMessage.success(msg || '申请提交成功')
      applyDialogVisible.value = false
      await loadPartnerApplyInfo()
      return
    }
    ElMessage.error(msg || '申请提交失败')
  } catch (error) {
    ElMessage.error('申请提交失败')
  } finally {
    applySubmitting.value = false
  }
}

onMounted(() => {
  initPage()
})
</script>

<style lang="less" scoped>
.partner-invite {
  max-width: 1400px;
  margin: 0 auto;
}

.welcome-box {
  margin-bottom: 24px;
  line-height: 1.6;
  background: #ffffff;
  padding: 25px 20px;
  .growth-tip {
    font-size: 14px;
    font-weight: 500;
    margin-top: 8px;
  }
}

.invite-tabs {
  margin-bottom: 24px;
  background: #ffffff;
  padding: 20px;
}

.info-card {
  border: 1px solid #dcdcdc;
  border-radius: 2px;
  background: #fff;
  padding: 24px;
  height: 415px;
  display: flex;
  flex-direction: column;
}

/* 左侧用户信息样式 */
.user-info-wrapper {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.user-avatar {
  background-color: #40c9a2; // 青绿色头像背景
  color: #fff;
}

.user-detail {
  flex: 1;
}

.name-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .label {
    color: #606266;
    margin-right: 8px;
  }
  .name-input {
    width: 200px;
  }
}

.info-line {
  margin-bottom: 16px;
  .label {
    color: #606266;
    margin-right: 8px;
  }
  .value {
    color: #303133;
  }
}

.user-type-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  .label {
    color: #606266;
    margin-right: 8px;
  }
}

.tip-text {
  color: #909399;
  font-size: 14px;
  margin-bottom: 16px;
}

.btn-group {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: auto;
}

.confirm-btn {
  background-color: #36a39c;
  border-color: #36a39c;
}

/* 中间入驻信息样式 */
.settle-content {
  margin-bottom: 16px;
}

.settle-title {
  font-size: 20px;
  color: #303133;
  margin-bottom: 12px;
  .red-num {
    color: #f56c6c; // 红色数字
  }
}

.inviter-title {
  font-size: 16px;
  color: #303133;
  margin: 16px 0;
}

.inviter-line {
  margin-bottom: 12px;
  .label {
    color: #606266;
    margin-right: 8px;
  }
  .value {
    color: #303133;
  }
}

.stat-bar {
  display: flex;
  background-color: #f5f7fa;
  border-radius: 4px;
  padding: 12px;
  margin-top: auto;
  .stat-item {
    flex: 1;
    text-align: center;
    .stat-label {
      color: #606266;
    }
    .stat-value {
      color: #303133;
      font-weight: 500;
    }
  }
}

/* 右侧平台指定伙伴样式 */
.partner-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.partner-title-main {
  font-size: 18px;
  line-height: 1.35;
  color: #1f2d3d;
  font-weight: 600;
}

.partner-title-tag {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(54, 163, 156, 0.12);
  color: #2c6f6a;
  font-size: 12px;
  font-weight: 500;
}

.partner-divider {
  margin: 10px 0 16px !important;
}

.empty-tip {
  text-align: center;
  padding: 40px 0;
  color: #909399;
  font-size: 16px;
}

.partner-apply-card {
  position: relative;
  overflow: hidden;
  height: 415px;
  background:
    radial-gradient(circle at top right, rgba(54, 163, 156, 0.14), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f8fcfb 100%);
}

.partner-status-box {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.partner-status-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
  padding: 16px;
  border: 1px solid #d8efeb;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
  box-sizing: border-box;
}

.partner-status-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.partner-status-summary {
  min-width: 0;
}

.partner-status-caption {
  margin: 0 0 6px;
  font-size: 13px;
  color: #7b8a8b;
}

.partner-status-main {
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
  color: #1f2d3d;
  font-weight: 600;
}

.partner-status-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.partner-status-meta {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.partner-status-meta-card {
  padding: 12px 14px;
  border-radius: 12px;
  background: #f4f8f8;

  .label {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
    color: #7b8a8b;
  }

  .value {
    display: block;
    color: #303133;
    line-height: 1.7;
    word-break: break-all;
  }
}

.partner-status-item {
  padding: 12px 14px;
  border-radius: 12px;
  background: #f4f8f8;
  min-width: 0;

  .label {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
    color: #7b8a8b;
  }

  .value {
    display: block;
    color: #303133;
    line-height: 1.6;
    word-break: break-all;
  }
}

.partner-status-item-full {
  grid-column: 1 / -1;
}

.partner-status-time-item {
  .value {
    white-space: nowrap;
  }
}

.partner-status-reason-item {
  .value {
    max-height: 88px;
    overflow-y: auto;
    padding-right: 4px;
    white-space: pre-wrap;
  }
}

.partner-profile-box {
  padding: 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(54, 163, 156, 0.12), rgba(54, 163, 156, 0.04));
}

.partner-profile-grid {
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

.partner-profile-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: rgba(255, 255, 255, 0.78);

  .label {
    flex: 0 0 56px;
    margin-bottom: 0;
    line-height: 1.8;
  }

  .value {
    flex: 1;
    word-break: normal;
    overflow-wrap: anywhere;
    line-height: 1.8;
  }
}

.partner-profile-item:not(.partner-status-item-full) {
  .value {
    white-space: nowrap;
  }
}

.partner-profile-item.partner-status-item-full {
  .value {
    white-space: normal;
  }
}

.partner-profile-title {
  margin: 0 0 12px;
  font-size: 0;
  line-height: 1;
}

.partner-profile-title::before {
  content: '原邀请人信息';
  font-size: 15px;
  font-weight: 600;
  color: #2c6f6a;
}

.partner-profile-title-fixed {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: #2c6f6a;
}

.partner-profile-fixed-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.partner-profile-fixed-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.78);
}

.partner-profile-fixed-label {
  flex: 0 0 56px;
  color: #7b8a8b;
  font-size: 12px;
  line-height: 1.8;
}

.partner-profile-fixed-value {
  flex: 1;
  min-width: 0;
  color: #303133;
  line-height: 1.8;
  word-break: normal;
  overflow-wrap: anywhere;
}

.partner-note-box {
  padding: 14px 16px;
  border-radius: 12px;
  background: #fff7ed;
  border: 1px solid #f6d8b4;

  .label {
    display: block;
    margin-bottom: 8px;
    font-size: 12px;
    color: #b26b20;
  }
}

.partner-note-text {
  margin: 0;
  line-height: 1.7;
  color: #7a4a12;
}

.partner-empty-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  min-height: 202px;
  border: 1px dashed #cfe4e1;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.85);
}

.empty-title {
  margin: 0 0 10px;
  font-size: 18px;
  color: #303133;
  font-weight: 500;
}

.empty-desc {
  margin: 0 auto;
  max-width: 260px;
  line-height: 1.7;
  font-size: 14px;
  color: #7b8a8b;
}

.apply-btn {
  width: 100%;
  height: 42px;
  margin-top: 14px;
  flex-shrink: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #36a39c, #4fb9ab);
  border-color: transparent;
  color: #ffffff !important;
  font-size: 15px;
  font-weight: 500;
}

.apply-btn:hover,
.apply-btn:focus {
  color: #ffffff !important;
  border-color: transparent;
  background: linear-gradient(135deg, #31958f, #49afa2);
}

.apply-btn.is-disabled,
.apply-btn.is-disabled:hover {
  background: #d6e9e6;
  color: #8aa4a1;
  border-color: transparent;
}

.apply-dialog-tip {
  margin-bottom: 18px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f4fbfa;
  border: 1px solid #d8efeb;
}

.apply-dialog-tip-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  color: #2c6f6a;
}

.apply-dialog-tip-text {
  margin: 0;
  line-height: 1.7;
  color: #5c6b6b;
}

/* 页面容器 */
.partner-plan-page {
  width: 100%;
  background: #ffffff;
  margin-top: 24px;
  box-sizing: border-box;

  .partner-plan-content {
    width: 1360px;
    margin: 20px;
    border: 1px solid #5bc4bf;
    border-radius: 8px;
    box-sizing: border-box;
  }
}

/* 顶部弧形标题栏 */
.header-container {
  background-color: #369a9a;
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 4px;
  margin-bottom: 24px;
  padding: 10px 0;
  text-align: center;
}

.title-text {
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
}

/* 通用模块样式 */
.module {
  margin-bottom: 32px;
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #ffffff;
}
.module-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  div {
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: #48a09c;
    color: #ffffff;
    font-size: 14px;
    border-radius: 2px;
  }
}

.module-title .title-text {
  font-size: 16px;
  font-weight: 500;
  color: #369a9a;
  margin-left: 8px;
}

/* 信件内容样式 */
.letter-content {
  font-size: 14px;
  color: #303133;
  line-height: 1.8;
  background: #f5f5f5;
  padding: 20px;
}
.letter-greeting {
  margin: 0 0 12px 0;
  font-weight: 500;
}
.section-title {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  margin: 16px 0 8px 0;
}
.reward-list {
  margin: 0 0 12px 24px;
  padding: 0;
}
.reward-list li {
  margin-bottom: 8px;
}
.tip-text {
  color: #606266;
  font-size: 13px;
  margin: 0 0 12px 0;
}
.closing-text {
  margin-top: 16px;
  font-weight: 500;
}

/* 成长路径模块样式 */
.benefits-content {
  font-size: 14px;
  color: #303133;
  line-height: 1.8;
  background: #f5f5f5;
  padding: 20px;
}
.benefits-title {
  font-size: 15px;
  font-weight: 500;
  margin: 0 0 12px 0;
}
.benefits-list {
  margin: 0 0 16px 24px;
  padding: 0;
}
.benefits-list li {
  margin-bottom: 8px;
}
.rules-tip {
  display: flex;
  align-items: center;
  margin: 16px 0 8px 0;
}
.tip-icon {
  color: #e6a23c;
  font-size: 16px;
  margin-right: 4px;
}
.tip-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}
.rules-text {
  color: #606266;
  font-size: 13px;
  line-height: 1.6;
  margin: 0 0 16px 0;
}
.current-level {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;
}
.level-label {
  color: #303133;
}
.level-tag {
  font-size: 12px;
}
.level-tip,
.level-desc {
  color: #606266;
  font-size: 12px;
}

/* 邀请链接模块（核心底部对齐布局） */
.invite-module {
  border-radius: 4px;
  padding: 20px;
  background: #ffffff;
}
.invite-content {
  position: relative;
  display: flex;
  min-height: 220px;
}
.invite-content::after {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: 100%;
  background: #e4e7ed;
  transform: translateX(-50%);
}
.invite-col {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 50%;
}
.invite-desc {
  font-size: 14px;
  color: #303133;
  line-height: 1.8;
  margin-bottom: 32px;
  flex-grow: 1; /* 占满剩余空间，将链接挤到底部 */
}
.invite-desc p {
  margin: 0 0 12px 0;
}
.link-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto; /* 强制固定在底部 */
}
.link-label {
  font-size: 14px;
  color: #909399;
}
.link-text {
  font-size: 14px;
  color: #303133;
  word-break: break-all;
}
.copy-btn {
  align-self: flex-start;
  color: #369a9a;
  font-size: 14px;
  padding: 0;
}
.copy-btn:hover {
  color: #2d8585;
}
</style>
